<template>
  <i-modal
    v-model="modal"
    title="保存した検索条件"
    width="800"
    class="modal_search_list"
    footer-hide
    @on-visible-change="onVisibleChange"
  >
    <div class="container">
      <template v-if="list && list.length === 0">
        <div class="no_data">
          検索条件が保存されていません。
        </div>
      </template>
      <template v-else>
        <table class="table">
          <tr v-for="(item, idx) in list" :key="`searchItem${idx}`">
            <td @dblclick="onDblClickSearch(item.search)">
              <div class="search_item">
                <div>
                  <div class="search_item__name">{{ item.name }}</div>
                  <div class="search_item__tag">
                    <template v-for="(tag, tagIdx) in item.tag">
                      {{ tag.tag }}
                      <template v-if="item.tag.length !== tagIdx + 1">
                        ・
                      </template>
                    </template>
                    <template v-if="item.search && item.search.search">
                      表示件数：{{ item.search.search.per_page }}件
                    </template>
                  </div>
                </div>
                <div>
                  <i-button type="error" size="small" @click="onClickDelete(item.id)">削除</i-button>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </template>
    </div>
  </i-modal>
</template>

<script>
import _ from 'lodash'
import { Modal, Button } from 'view-design'
import SearchConditionRepository from '@/repositories/searchConditionRepository.js'

export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
  },
  data() {
    return {
      modalLoading: false,
      list: null,
    }
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalSearchConditions/getModal']
      },
      set(val) {
        this.$store.commit('ModalSearchConditions/setModal', val)
      },
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        this.getSearchList()
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // 検索一覧取得処理
    async getSearchList() {
      const type = this.type
      this.modalLoading = true
      await SearchConditionRepository.get(type)
        .then(res => {
          if (res.result) {
            this.list = res.data
          } else {
            alert('検索項目の取得に失敗しました。')
            this.modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('検索項目の取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // 検索処理
    onDblClickSearch(search) {
      // 検索条件セット
      this.$emit('searchReset')
      this.$store.commit('SearchProperty/setSearch', search.search)
      this.$emit('search')
      this.modal = false
    },
    // キャンセルボタン クリック処理
    onClickDelete(id) {
      if (window.confirm('削除しますか？')) {
        // 削除処理
        this.delete(id)
      }
    },
    // 検索一覧削除処理
    async delete(id) {
      this.modalLoading = true
      await SearchConditionRepository.delete(id)
        .then(res => {
          if (res.result) {
            // 検索項目削除処理
            this.list = _.reject(this.list, { id: id })
            alert(`${res.message}`)
          } else {
            alert('検索項目の削除に失敗しました。')
            this.modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('検索項目の削除に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // パラメータを初期化する
    resetParams() {
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'
      // this.modal.type = ''
      this.list = null
    },
  },
}
</script>

<style lang="scss" scoped>
.modal_search_list {
  .container {
    min-height: 240px;
    max-height: 320px;
    overflow: scroll;
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 16px;
    tr {
      background-color: #fff;
      transition: all 0.6s ease;
      cursor: pointer;
      &:hover {
        background-color: #f0f0f0;
      }
    }

    td {
      vertical-align: middle;
      font-size: 12px;
      padding: 8px 16px;
      border: 1px solid #cfcfcf;
    }
  }
  .search_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__name {
      display: block;
      font-size: 14px;
      font-weight: bold;
    }
    &__tag {
      width: 640px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .no_data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 190px;
    font-weight: bold;
  }
}
</style>
